import { useQuery } from 'react-query';
import { fetchHuluOriginals } from '../services/api';

export const useHuluOriginals = options => {
  return useQuery('huluOriginals', fetchHuluOriginals, options);
};
